
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13 3.87003V3.89003C13 4.56003 13.45 5.12003 14.08 5.32003C16.93 6.21003 19 8.86003 19 12C19 12.52 18.94 13.01 18.83 13.49C18.69 14.13 18.95 14.79 19.52 15.13L19.53 15.14C20.39 15.64 21.51 15.19 21.74 14.23C21.91 13.51 22 12.76 22 12C22 7.50003 19.02 3.68003 14.92 2.43003C13.97 2.14003 13 2.87003 13 3.87003ZM10.94 18.92C7.94998 18.49 5.51997 16.06 5.07997 13.08C4.53997 9.48003 6.73997 6.31003 9.90997 5.32003C10.55 5.13003 11 4.56003 11 3.89003V3.87003C11 2.87003 10.03 2.14003 9.06997 2.43003C4.55997 3.81003 1.40997 8.29003 2.08997 13.39C2.67997 17.77 6.21998 21.31 10.6 21.9C13.74 22.32 16.64 21.29 18.73 19.37C19.47 18.69 19.34 17.48 18.47 16.98C17.89 16.64 17.17 16.75 16.67 17.2C15.2 18.54 13.16 19.25 10.94 18.92Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-data-usage`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconDataUsage

    ```js
    <b-new-b-icon-data-usage />
    ```
</docs>


